import styled from 'styled-components'
import { Pagination, Button, Empty, Typography, Modal } from 'antd'
import { IconFont, DeleteModal, SvgIcon, SignTitle, FilterForm } from '@/components'
import {
  useGetAttachments,
  useDelAttachmentDetail,
  useGetAttachmentsDownload,
  useGetAttachmentAttck,
} from './utils'
import { useDebounceFn } from 'ahooks'
import { useState } from 'react'
import { GetAttachments } from '@/api/template'
import { EditTemplate } from './edit-template'
import { GetPhishingParamsCreateTemplate } from './create-template'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { Message } from '@/components/message'
import { t } from '@/i18n'
export const AcessoryTemplate = () => {
  const [getAttachmentsParams, setGetAttachmentsParams] = useState<GetAttachments>({
    limit: 20,
    page: 1,
    name: '',
    origin_type: 0,
    attachment_type: 0,
  })
  const [getAttachmentsDownload] = useGetAttachmentsDownload()
  const { run } = useDebounceFn(
    value => {
      setGetAttachmentsParams(origin => ({ ...origin, page: 1, name: value }))
    },
    {
      wait: 500,
    },
  )
  const [visible, setVisible] = useState({ visible: false, id: null, type: null })
  function close(data) {
    if (data) {
      getAttachments()
    }
    setVisible({ visible: false, id: null, type: null })
  }
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [attckVisible, setAttckVisible] = useState({ visible: false, list: [] })
  const [delAttachmentDetail] = useDelAttachmentDetail()
  const [getAttachments, attachmentsList] = useGetAttachments({
    GetAttachmentsParams: getAttachmentsParams,
  })
  const [attckList] = useGetAttachmentAttck()
  const handleCancel = data => {
    if (data) {
      getAttachments()
    }
    setIsModalVisible(false)
  }
  const [deleteModal, setDeleteModal] = useState({ visible: false, id: null })
  const deleteEmailHandler = async () => {
    try {
      await delAttachmentDetail({ id: deleteModal.id })
      Message.success('删除成功')
      if (
        getAttachmentsParams.page > 1 &&
        (getAttachmentsParams.page - 1) * getAttachmentsParams.limit + deleteModal.id?.length >=
          attachmentsList.total
      ) {
        setGetAttachmentsParams(origin => ({ ...origin, page: getAttachmentsParams.page - 1 }))
      } else {
        await getAttachments()
      }

      setDeleteModal({ visible: false, id: null })
    } catch (err) {}
  }
  const download = (name: string, id: string) => {
    getAttachmentsDownload({ template_id: id }).catch(err => {
      if (err?.code) {
        return
      }
      const blob = window.URL.createObjectURL(new Blob([err]))
      const aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = blob
      aLink.download = name
      document.body?.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    })
  }

  let option = {
    name: {
      type: 'input',
      label: '附件名称',
    },
    origin_type: {
      type: 'radio',
      label: '模板类型',
      data: [
        { name: '系统内置', id: 1 },
        { name: '自定义', id: 2 },
      ],
    },
    attachment_type: {
      type: 'radio',
      label: '附件类型',
      data: [
        { name: 'EXE', id: 1 },
        { name: 'DOC/X', id: 2 },
        { name: 'XLS/X', id: 3 },
        { name: 'PPT/X', id: 4 },
        { name: 'PDF', id: 5 },
        { name: 'RTF', id: 6 },
      ],
    },
    attck_name: {
      type: 'multiple',
      label: 'ATT&CK',
      data: attckList?.map(item => ({ name: item.name, id: item.name })),
      typeof: 'array',
    },
  }
  // const [visibleSearch, setVisibleSearch] = useState(false)
  const onFinish = values => {
    const { time, template, attachment, attck_name } = values
    setGetAttachmentsParams(origin => ({
      ...origin,
      origin_type: template,
      attachment_type: attachment,
      page: 1,
      attck_name,
    }))
    // setVisibleSearch(false)
  }
  return (
    <Template>
      <div className="title-btn">
        <Button type="primary" onClick={() => setIsModalVisible(true)}>
          {t('添加自定义模板')}
        </Button>
      </div>
      <FilterForm
        option={option}
        setSearchParams={setGetAttachmentsParams}
        setFilterHeight={v => {
          console.log(v)
        }}
        onReset={() => {
          setGetAttachmentsParams({
            page: 1,
            limit: 10,
          })
        }}
      />

      {/* <AdvancedPopover
         option={option}
         onConfirm={onFinish}
         left={
           <Button type="primary" onClick={() => setIsModalVisible(true)}>
             添加自定义模板
           </Button>
         }
         buttonLeft={
           <SearchInput
             inputProps={{
               placeholder: '附件名称',
               onChange: e => run(e.target.value),
             }}
           />
         }
        /> */}
      <GetPhishingParamsCreateTemplate
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        cont={'3'}
      />

      <EditTemplate isModalVisible={visible} handleCancel={close} />
      <Main>
        {attachmentsList?.items?.map(item => (
          <div className="list-main" key={item?.id}>
            {item?.origin_type === 1 && <div className="hint">{t('系统内置')}</div>}
            {<div className="custom">{t('自定义')}</div>}
            <div
              className="list"
              key={item?.id}
              style={{
                height: item?.origin_type === 2 ? 'calc(100% - 32px)' : 'calc(100% - 60px)',
              }}
            >
              <div className="img-main">
                {item?.attachment_type === 1 && (
                  <SvgIcon name={'exe'} width={'64px'} height={'64px'} />
                )}
                {item?.attachment_type === 2 && (
                  <SvgIcon name={'doc-x'} width={'64px'} height={'64px'} />
                )}
                {item?.attachment_type === 3 && (
                  <SvgIcon name={'xls-x'} width={'64px'} height={'64px'} />
                )}
                {item?.attachment_type === 4 && (
                  <SvgIcon name={'ppt-x'} width={'64px'} height={'64px'} />
                )}
                {item?.attachment_type === 5 && (
                  <SvgIcon name={'pdf'} width={'64px'} height={'64px'} />
                )}
                {item?.attachment_type === 6 && (
                  <SvgIcon name={'rtf'} width={'64px'} height={'64px'} />
                )}
              </div>
              <div className="headline">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    className="text"
                    style={{
                      wordWrap: 'break-word',
                      wordBreak: 'break-all',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {t('附件：')}
                    {item?.attachment_name}
                  </div>
                  {item?.origin_type === 2 && (
                    <IconFont
                      style={{ fontSize: 16, marginLeft: 5 }}
                      onClick={() => download(item?.attachment_name, item?.id)}
                      type={'icon-xiazai2'}
                    />
                  )}
                </div>
              </div>
            </div>
            {item?.origin_type === 1 && (
              <div className="attck-container">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className="label">ATT&CK：</div>
                  {item?.attck?.length > 1 && (
                    <div
                      className="more"
                      onClick={() => {
                        setAttckVisible({ visible: true, list: item?.attck })
                      }}
                    >
                      {t('更多')}
                    </div>
                  )}
                </div>
                <div className="content">
                  {item?.attck?.[0] ? (
                    <Typography.Text
                      ellipsis={{
                        tooltip: {
                          title: item?.attck?.[0]?.name,
                          getPopupContainer: () => document.body,
                        },
                      }}
                    >
                      {/*{item?.attck?.[0]?.name}*/}
                      <a href={item?.attck?.[0]?.url} target="_blank" rel="noopener noreferrer">
                        {item?.attck?.[0]?.name}
                      </a>
                    </Typography.Text>
                  ) : (
                    '-'
                  )}
                </div>
              </div>
            )}
            {item?.origin_type === 2 && (
              <div className="examine">
                <div
                  className="operation"
                  onClick={() => setVisible({ visible: true, id: item.id, type: 3 })}
                >
                  <IconFont type={'icon-bianji'} />
                  &nbsp;
                  <span> {t('编辑')}</span>
                </div>
                <div
                  className="operation"
                  onClick={() => setDeleteModal({ visible: true, id: item?.id })}
                >
                  <IconFont type={'icon-shanchu-m'} />
                  &nbsp;
                  <span>{t('删除')}</span>
                </div>
              </div>
            )}
          </div>
        ))}
      </Main>
      {!attachmentsList?.items && <Empty image={EmptyImg} />}
      <AttckModal
        centered
        width={560}
        visible={attckVisible.visible}
        title={<SignTitle show>ATT&CK</SignTitle>}
        footer={null}
        destroyOnClose
        // bodyStyle={{ height: 300, overflow: 'scroll' }}
        onCancel={() => {
          setAttckVisible({ visible: false, list: [] })
        }}
      >
        {attckVisible.list?.map((item, index) => (
          <div className="item" key={index}>
            <a href={item.url} target="_blank" rel="noopener noreferrer">
              {item.name}
            </a>
          </div>
        ))}
      </AttckModal>
      <DeleteModal
        onOk={deleteEmailHandler}
        onCancel={() => {
          setDeleteModal({ visible: false, id: null })
        }}
        visible={deleteModal.visible}
        text={'此操作将永久删除,是否继续?'}
      />

      {attachmentsList?.items && (
        <div className="pageination">
          <Pagination
            onChange={(page, limit) => {
              setGetAttachmentsParams(origin => ({ ...origin, page, limit }))
            }}
            defaultCurrent={1}
            total={attachmentsList?.total}
            showSizeChanger
            showQuickJumper
            current={getAttachmentsParams.page}
            pageSize={getAttachmentsParams.limit}
            defaultPageSize={20}
            pageSizeOptions={['20', '40', '60', '80', '100']}
            showTotal={totals => (
              <div>
                {t('共')}
                <a>{totals}</a>
                {t('条')}
              </div>
            )}
          />
        </div>
      )}
    </Template>
  )
}
const AttckModal = styled(Modal)`
  .item {
    width: 480px;
    //height: 32px;
    line-height: 22px;
    background: #f7f7f7;
    border-radius: 6px;
    padding: 4px 16px;
    margin-bottom: 8px;
  }
  .ant-modal-body {
    padding: 20px 36px;
    height: 300px;
    overflow: scroll;
  }
`
const Template = styled.div`
  .title-btn {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 10px;
    padding: 0 20px;
  }
  .pageination {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    margin-right: 20px;
  }
  .ant-popover-title {
    height: 50px;
    display: flex;
    align-items: center;
  }
  .search-button {
    background: #f1f3f8;
    border-radius: 6px;
    padding: 9px 18px;
    margin-left: 10px;
    cursor: pointer;
    &:hover {
      color: #0b0a27;
      background: #e2e4f6;
    }
  }
`
const Main = styled.div`
  padding: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(327px, 1fr));
  grid-gap: 20px;
  padding: 0 20px;
  .list-main {
    background-color: #ffffff;
    border-radius: 8px;
    height: 160px;
    border: 1px solid #d9d9d9;
    position: relative;
    overflow: hidden;
    .hint {
      position: absolute;
      right: -1px;
      top: -1px;
      background: #558492;
      border-radius: 0px 8px 0px 8px;
      color: #fff;
      font-size: 14px;
      padding: 4px 6px;
      z-index: 1;
    }
    .custom {
      position: absolute;
      right: -1px;
      top: -1px;
      background: #ed787e;
      border-radius: 0px 8px 0px 8px;
      color: #fff;
      font-size: 14px;
      padding: 4px 6px;
    }
  }
  .list {
    width: 100%;
    background: #ffffff;
    padding: 26px 20px 10px 20px;
    display: flex;
    height: 100%;
    align-items: center;
  }
  .attck-container {
    width: 100%;
    height: 60px;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 8px 12px;
    border-top: 1px dashed #eaedf1;
    .label {
      color: #666;
    }
    .more {
      cursor: pointer;
      color: #666666;
      &:hover {
        color: #4238c9;
      }
    }
    .content {
      margin-top: 4px;
      height: 24px;
      background: #f7f7f9;
      border-radius: 6px;
      padding: 0 6px;
      line-height: 24px;
    }
  }
  .examine {
    height: 30px;
    background: #f1f1f1;
    border-radius: 0px 0px 8px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
    width: 100%;
    .operation {
      flex: 1;
      text-align: center;
      border-left: 1px solid #d9d9d9;
      &:nth-child(1) {
        border: 0;
      }
    }
  }
  .headline {
    margin-left: 20px;
    width: calc(100% - 84px);
  }
  .title {
    line-height: 1.2;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .img-main {
    width: 64px;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
